import { useEffect } from 'react';
import { SegmentClient } from '@frontman/utils';

function useSegmentInitialize(segmentApiKey: string): void {
  useEffect(() => {
    if (!segmentApiKey) {
      console.log('Segment not initialized');
      return;
    }

    SegmentClient.initialize({
      segmentWriteKey: segmentApiKey,
    });

    console.log('Segment initialized');
  }, []);
}

export { useSegmentInitialize };
